/* eslint-disable */ 
import { signObj } from '@/utils/plugins/SignMessenger'
import store from '@/store'
import Vue from 'vue'
/*获取证书DN*/
export const GetCertDN = function (websock, ctrl) {
  var certDn = null;
  if (!websock) {
    ctrl = document.getElementById("CBIB");
    //!!! lRet 必须暴露到全局
    window.lRet = ctrl.GetCertDN();
    if (window.lRet == '') {
      Vue.prototype.$talert("获取证书DN失败,请确认插入的usb-key是否正确！")
    }
  } else {
    ctrl.GetCertDN(function (result, response) {
      if (!result) {
        Vue.prototype.$talert("获取证书DN失败,请确认插入的usb-key是否正确！")
      } else {
        window.lRet = response;
      }
    })
  }
  certDn = window.lRet;
  if (certDn != '' && certDn != null) {
    certDn = certDn.split(',')[0];
  }
  return certDn;
}

/* 签名数据
 *  var result = signObj.sSign(dn , content , parseInt(signType) + parseInt(hashType) + parseInt(keyType));
 *  signType=0:P7 Attach，16：P7 Detach，32：RAW;hashType=0:SHA1，5：SM3;keyType=512:二代UKey，0：一代UKey/软证书;
 */
export const SignData = function (message, certDN) {
  var signData = signObj.sSign(certDN, message, parseInt("16") + parseInt("0") + parseInt("512"));
  return signData;
}

/*
 * 判断字符串是否为Json
 */
export const isJsonString = function (str) {
  try {
    if (typeof JSON.parse(str) == "object") {
      return true;
    }
  } catch (e) {
    return false;
  }
}

// 当前浏览器是否需要websocket连接
export const needWebsock = function () {
  const browserName = navigator.appName
  const browserNum = parseInt(navigator.appVersion)
  if (((browserName === 'Microsoft Internet Explorer') && (browserNum >= 4)) || (navigator.userAgent.indexOf('Trident') >= 0)) {
    return false
  }
  return true
}

// 将信息转译成xml 供签名控件操作
export const getSignedMessage = function ({ obviousInfo = {}, hiddenInfo = {}, showObviousColon = true, showHiddenColon = false }) {
  // FIXME: 如果要翻译的话 这里需要加$t 但同样的后端接口是不是也要更改
  function getItemXml (info, colon = true) {
    let xml = ''
    for (var key in info) {
      xml += `<M><k>${key}${colon ? '：' : ''}</k><v>${info[key]}</v></M>`
    }
    return xml
  }
  // 将obviousInfo转化为xml标签
  const obviousXml = getItemXml(obviousInfo, showObviousColon)
  // 将hiddenInfo转化为xml标签
  const hiddenXml = getItemXml(hiddenInfo, showHiddenColon)
  const xml = `<?xml version="1.0" encoding="UTF-8"?><T><D>${obviousXml}</D><E>${hiddenXml}</E></T>`
  // 打印消息
  process.env.VUE_APP_TARGET !== 'PROD' && console.warn(xml)
  return xml
}

// 将xml加密成signdata
export const getSignData = function (xml) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // TODO:是否安装签名控件
      const websock = needWebsock()
      // 是否插入ukey
      const certDN = GetCertDN(websock, window.ukeyCtrl)
      if (!certDN) {
        this.$err('请插入ukey')
        reject(false)
        return
      }
      const signData = SignData(xml, certDN)
      if (isJsonString(signData) && !websock) {
        const messageInfo = JSON.parse(signData)
        const { code, message } = messageInfo
        if (code === '2148073504') {
          this.$warn('用户取消了操作')
          reject(false)
        } else {
          this.$warn(message)
          reject(false)
        }
        return
      } else if (websock) {
        if (!signData) {
          this.$warn('用户取消了操作')
          reject(false)
          return
        }
      } else {
        if (!signData) {
          this.$warn('签名失败，请确认签名证书是否启用!')
          reject(false)
          return
        }
      }
      resolve(signData)
    })
  })
}

export const getSignDataByObj = function (info, callback) {
  const xml = getSignedMessage(info)
  const { appInfo: { APP_SIGNDATA_ENABLED } } = store.state.app
  if (APP_SIGNDATA_ENABLED) {
    getSignData.call(this, xml).then(signData => {
      callback && callback(signData)
    }).catch(err => {
      console.error(err)
    })
  } else {
    callback && callback()
  }
}
